import { useState } from "react";
import { TaxRatesEntity } from "src/@types/catalog/taxRates";
import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";

const useTaxRates = (selectedComplianceStandard?: string | undefined) => {
  const [taxRates, setTaxRates] = useState<null | TaxRatesEntity[]>(null);
  const handleFetchTaxRates = async () => {
    await GetAsync(`${API_GATEWAY}/api/catalogService/taxes`).then((res) => {
      if (res.status === 200) {
        if (!selectedComplianceStandard) {
          setTaxRates(res.data.taxRates);
        } else {
          const compliantTaxRates: TaxRatesEntity[] = res.data.taxRates
            .filter(
              (taxRate: TaxRatesEntity) =>
                taxRate.complianceStandard === selectedComplianceStandard,
            )
            .map((item: TaxRatesEntity) => item);
          setTaxRates(compliantTaxRates);
        }
      }
    });
  };

  return { taxRates, handleFetchTaxRates };
};

export default useTaxRates;
